import { cn } from '../../lib/utils'

interface FormInputProps {
  label: string
  name: string
  value: string | undefined
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  type?: 'text' | 'email' | 'url' | 'tel' | 'password' | 'number' | 'date'
  placeholder?: string
  required?: boolean
  disabled?: boolean
  className?: string
  helperText?: string
}

export function FormInput({
  label,
  name,
  value,
  onChange,
  type = 'text',
  placeholder,
  required = false,
  disabled = false,
  className = '',
  helperText,
}: FormInputProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <label htmlFor={name} className="block text-sm font-medium text-neutral-700">
        {label} {required && <span className="text-error-500">*</span>}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        value={value ?? ''}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className="w-full px-3 py-2 text-sm border border-neutral-200 bg-white text-neutral-900 rounded-lg focus:ring-2 focus:ring-primary-500/15 focus:border-primary-500 transition-colors duration-150 hover:border-neutral-300 disabled:bg-neutral-50 disabled:text-neutral-400 disabled:cursor-not-allowed placeholder:text-neutral-400"
      />
      {helperText && <p className="text-xs text-neutral-400">{helperText}</p>}
    </div>
  )
}
